import { Box } from '@mui/material';
import ActiveComponent from './ActiveComponent';
import StandbyComponent from './StandbyComponent';
import ObserverComponent from './ObserverComponent';
import HearbeatSetting from './HearbeatSetting';
import { useTriConnection } from './hooks';
import ConnectionArrow from './ConnectionArrow';
import { useAuthForm } from '../../../Auth/hooks';
import { IGetStatus } from '../../../../store/api/admin/types';

interface IGetCongiguration {
  active2standby_connection_alive: boolean;
  active2observer_connection_alive: boolean;
  standby2observer_connection_alive: boolean;
}

const TriSync = () => {
  const { data, isLoading, error, statusData } = useTriConnection();
 
  const safeStatusData = statusData as unknown as IGetCongiguration;

  return (
    <>
    <Box sx={{ display: 'flex', width: '100%', position: 'relative', height: '75vh' }}>
      {/* Left Side - 70% of the width */}
      <Box sx={{ width: '70%', position: 'relative' }}>
        {/* Active Component */}
        <Box id="active" sx={{
          position: 'absolute',
          // top: '5%',
          left: '15%',
        }}>
          <ActiveComponent />
        </Box>

        {/* Observer Component */}
        <Box id="observer" sx={{
          position: 'absolute',
          bottom: '30%',
          right: '8%',
        }}>
          <ObserverComponent />
        </Box>

        {/* Standby Component */}
        <Box id="standalone" sx={{
          position: 'absolute',
          bottom: '0',
          left: '15%',
        }}>
          <StandbyComponent />
        </Box>
      </Box>

      {/* Right Side - 30% width */}
      <Box sx={{ width: '30%', padding: 2}}>
        <HearbeatSetting />
      </Box>
    </Box>
    {/* <Xarrow
          start="active"
          end="observer"
          color="green"
          strokeWidth={3}
          showHead={false}
          path="straight"
        />
        <Xarrow
          start="observer"
          end="standalone"
          color="grey"
          strokeWidth={3}
          showHead={false}
          path="straight"
          dashness
          labels={{
            middle:(<Box><img src={cross}/></Box>)
          }}
        />
        <Xarrow
          start="standalone"
          end="active"
          color="green"
          strokeWidth={3}
          showHead={false}
          path="straight"
          labels={{
            middle:(<Box><img src={checkmark}/></Box>)
          }}
        /> */}
        <ConnectionArrow start="active" end="observer" isConnected={safeStatusData?.active2observer_connection_alive} />
      <ConnectionArrow start="standalone" end="active" isConnected={safeStatusData?.active2standby_connection_alive} />
      <ConnectionArrow start="standalone" end="observer" isConnected={safeStatusData?.standby2observer_connection_alive} />
    </>
  );
};

export default TriSync;
